import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=636a919a"
import script from "./EditTemplate.vue?vue&type=script&lang=js"
export * from "./EditTemplate.vue?vue&type=script&lang=js"
import style0 from "./EditTemplate.vue?vue&type=style&index=0&id=636a919a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports